export enum ActivityActions {
  CREATE = 'create',
  READ = 'read',
  FAILED = 'failed',
  EXPIRED = 'expired'
}
